// extracted by mini-css-extract-plugin
export default {"gallery":"getintouchimages_gallery__evaN2"};